<adapt-two-column-layout [fullPage]="true"
                         leftColumnWidthClasses="col p-0"
                         rightColumnWidthClasses="col-auto"
                         class="activity-calendar">
    <div left-column
         class="h-100 d-flex flex-column p-3"
         #container>
        <bs-alert type="info"
                  [dismissible]="true">
            This calendar shows activities inside {{ProjectLabel}} only.
            It does not integrate with your personal or work calendar (e.g. Outlook / Google).
        </bs-alert>

        <ng-content></ng-content>

        <dx-load-panel [visible]="isFirstUpdate"
                       [container]="container"></dx-load-panel>

        <dx-scheduler #scheduler
                      [dataSource]="dataSource"
                      [remoteFiltering]="true"
                      [editing]="false"
                      [shadeUntilCurrentTime]="true"
                      [(currentDate)]="schedulerDate"
                      currentView="month"
                      startDateExpr="startDate"
                      endDateExpr="endDate"
                      allDayExpr="isAllDay"
                      textExpr="title"
                      class="flex-grow-1 h-100"
                      appointmentTemplate="appointmentTemplate"
                      appointmentTooltipTemplate="appointmentTooltip"
                      (onContentReady)="onCalendarLoad($event)"
                      (onAppointmentRendered)="onAppointmentRendered($event)"
                      (onCellClick)="onCalendarCellClick($event)"
                      (onAppointmentClick)="onAppointmentClick($event, scheduler.currentView)"
                      (onAppointmentFormOpening)="onAppointmentFormOpening($event)">
            <dxi-resource label="Type"
                          fieldExpr="type"
                          valueExpr="type"
                          displayExpr="shortTitle"
                          colorExpr="colourAccent"
                          [dataSource]="CulturalActivityTypeMetadata"
                          [useColorAsDefault]="true"></dxi-resource>
            <dxi-view type="workWeek"></dxi-view>
            <dxi-view type="month"></dxi-view>
            <dxi-view type="agenda"
                      [agendaDuration]="31"></dxi-view>
            <div *dxTemplate="let data of 'appointmentTemplate'"
                 (mouseenter)="onAppointmentHover($event, data)"
                 (mouseleave)="onAppointmentLeave()">
                <ng-container *ngIf="scheduler.currentView === 'agenda'; else normalAppointment">
                    <div class="dx-scheduler-agenda-appointment-left-layout">
                        <div class="dx-scheduler-agenda-appointment-marker"></div>
                    </div>
                    <div class="dx-scheduler-agenda-appointment-right-layout">
                        <div class="dx-scheduler-appointment-title">{{data.appointmentData.title}}</div>
                        <div class="dx-scheduler-appointment-content-details gap-2">
                            <div>{{data.appointmentData.metadata.shortTitle}}</div>
                            <div *ngIf="!data.appointmentData.isAllDay"
                                 class="dx-scheduler-appointment-content-date d-inline-flex align-items-center gap-1">
                                <i class="fal fa-fw fa-clock"></i>
                                {{data.appointmentData.startDate | adaptTime}}
                                <ng-container *ngIf="data.appointmentData.endDate">
                                    - {{data.appointmentData.endDate | adaptTime}}
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-template #normalAppointment>{{data.appointmentData.title}}</ng-template>
            </div>
            <div *dxTemplate="let data of 'appointmentTooltip'"
                 class="text-start">
                @if (calendarActivities.get(data.appointmentData.activityKey ?? ""); as activity) {
                    <ng-container *ngTemplateOutlet="activityTemplate; context: {$implicit: activity, actionable: false}"></ng-container>
                }
            </div>
        </dx-scheduler>
    </div>

    <ng-container right-column>
        <adapt-universal-dashboard-element *ngIf="selectedCellData"
                                           name="Due on {{selectedCellData.date | adaptDate}}"
                                           class="flex-shrink-0">
            <span adapt-header-action-right
                  type="button"
                  (click)="selectedCellData = undefined; updateCalendarDimensions()"
                  class="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"></span>

            <div class="d-flex flex-column gap-1">
                <p *ngIf="selectedCellData.activities.length === 0"
                   class="no-activity-placeholder">No activities fall on this date.</p>
                <ng-container *ngFor="let group of selectedCellData.activities; trackBy: groupTrackBy">
                    <adapt-universal-dashboard-element *ngIf="CulturalActivityMetadataByType[group.key] as typeMetadata"
                                                       [name]="typeMetadata.title"
                                                       [background]="false"
                                                       [nested]="true"
                                                       [url]="routes[group.key]">
                        <div class="d-flex flex-row flex-wrap gap-3">
                            <ng-container *ngFor="let activity of group.items; trackBy: activityTrackBy">
                                <ng-container *ngTemplateOutlet="activityTemplate; context: {$implicit: activity, highlight: false}"></ng-container>
                            </ng-container>
                        </div>
                    </adapt-universal-dashboard-element>
                </ng-container>
            </div>
        </adapt-universal-dashboard-element>
    </ng-container>
</adapt-two-column-layout>
